// src/components/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const email = (() => { try { return localStorage.getItem("userEmail"); } catch { return null; } })();
  return email ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
